import {
  LuWifi,
  LuCircleParking,
  LuAirVent,
  LuShieldCheck,
  LuZap,
  LuSparkles
} from "react-icons/lu";

export const amenities = [
  {
    title: "High-Speed Wi-Fi",
    description: "Seamless connectivity across all rooms and common areas.",
    icon: LuWifi,
  },
  {
    title: "24×7 Front Desk",
    description: "Dedicated assistance available round the clock.",
    icon: LuShieldCheck,
  },
  {
    title: "Air Conditioned Rooms",
    description: "Individually controlled air conditioning for maximum comfort.",
    icon: LuAirVent,
  },
  {
    title: "Secure Parking",
    description: "Convenient and safe parking facilities for all guests.",
    icon: LuCircleParking,
  },
  {
    title: "Power Backup",
    description: "Uninterrupted power supply ensuring a worry-free stay.",
    icon: LuZap,
  },
  {
    title: "Housekeeping",
    description: "Daily housekeeping maintaining refined cleanliness.",
    icon: LuSparkles,
  },
];